import ImageAIFusion from '@/assets/images/partners/partners-aif.png';
import ImageAnimoca from '@/assets/images/partners/partners-animoca.png';
import ImageAvalanche from '@/assets/images/partners/partners-avalanche.png';
import ImageAws from '@/assets/images/partners/partners-aws.png';
import ImageBitTrade from '@/assets/images/partners/partners-bittrade.png';
import ImageChainlink from '@/assets/images/partners/partners-chainlink.png';
import ImageCoinplug from '@/assets/images/partners/partners-coinplug.png';
import ImageCoinpost from '@/assets/images/partners/partners-coinpost.png';
import ImageConflux from '@/assets/images/partners/partners-conflux.png';
import ImageCore from '@/assets/images/partners/partners-core.png';
import ImageCube from '@/assets/images/partners/partners-cube.png';
import ImageDelight from '@/assets/images/partners/partners-delight.png';
import ImageGainsTrade from '@/assets/images/partners/partners-gains_trade.png';
import ImageJoc from '@/assets/images/partners/partners-joc.png';
import ImageKanalabs from '@/assets/images/partners/partners-kanalabs.png';
import ImageKddi from '@/assets/images/partners/partners-kddi.png';
import ImageKica from '@/assets/images/partners/partners-kica.png';
import ImageMch from '@/assets/images/partners/partners-mch.png';
import ImageNansen from '@/assets/images/partners/partners-nansen.png';
import ImageNeo from '@/assets/images/partners/partners-neo.png';
import ImageOasys from '@/assets/images/partners/partners-oasys.png';
import ImageOkj from '@/assets/images/partners/partners-okj.png';
import ImageOpensea from '@/assets/images/partners/partners-opensea.png';
import ImagePacificMeta from '@/assets/images/partners/partners-pacificmeta.png';
import ImagePlanz from '@/assets/images/partners/partners-planz.png';
import ImagePolygon from '@/assets/images/partners/partners-polygon.png';
import ImageSix from '@/assets/images/partners/partners-six.png';
import ImageSlash from '@/assets/images/partners/partners-slash.png';
import ImageStacks from '@/assets/images/partners/partners-stacks.png';
import ImageSynfutures from '@/assets/images/partners/partners-synfutures.png';
import ImageTheori from '@/assets/images/partners/partners-theori.png';
import ImageThepol from '@/assets/images/partners/partners-thepol.png';

export const PARTNERS = [
  { name: 'Animoca', image: ImageAnimoca },
  { name: 'AI Fusion', image: ImageAIFusion },
  { name: 'Gains Trade', image: ImageGainsTrade },
  { name: 'Coinpost', image: ImageCoinpost },
  { name: 'AWS', image: ImageAws },
  { name: 'NANSEN ', image: ImageNansen },
  { name: 'KDDI', image: ImageKddi },
  { name: 'Pacific Meta', image: ImagePacificMeta },
  { name: 'OKJ', image: ImageOkj },
  { name: 'Bit Trade', image: ImageBitTrade },
  { name: 'Oasys', image: ImageOasys },
  { name: 'MCH', image: ImageMch },
  { name: 'PLANZ', image: ImagePlanz },
  { name: 'Core', image: ImageCore },
  { name: 'Japan Open Chain', image: ImageJoc },
  { name: 'Slash', image: ImageSlash },
  { name: 'Syn Futures', image: ImageSynfutures },
  { name: 'THEPOL', image: ImageThepol },
  { name: 'Neo', image: ImageNeo },
  { name: 'Conflux', image: ImageConflux },
  { name: 'Stacks', image: ImageStacks },
  { name: 'Theori', image: ImageTheori },
  { name: 'Cube', image: ImageCube },
  { name: 'Delight', image: ImageDelight },
  { name: 'Avalanche', image: ImageAvalanche },
  { name: 'Six Network', image: ImageSix },
  { name: 'KICA', image: ImageKica },
  { name: 'Open Sea', image: ImageOpensea },
  { name: 'Polygon', image: ImagePolygon },
  { name: 'Kanalabs', image: ImageKanalabs },
  { name: 'Coinplug', image: ImageCoinplug },
  { name: 'Chainlink', image: ImageChainlink },
];
